import ModalWrapper from 'dashboard/components/ModalWrapper';
import { ModalBody, ModalContainer, ModalHeader } from 'dashboard/layouts/ModalLayout';

export interface ExternalIntegrationOAuthErrorModalProps {
  isOpen: boolean;
  handleClose: () => void;
}
const ExternalIntegrationOAuthErrorModal = ({
  isOpen,
  handleClose,
}: ExternalIntegrationOAuthErrorModalProps) => {
  return (
    <ModalWrapper isOpen={isOpen} handleCloseModal={handleClose}>
      <ModalContainer data-test='external-integration-modal__oauth-error'>
        <ModalHeader data-test='external-integration-modal__oauth-error' onClose={handleClose}>
          Error
        </ModalHeader>
        <ModalBody>
          The resource owner or authorization server denied the request. Please ensure that you are
          authorized to install OAuth applications.
        </ModalBody>
      </ModalContainer>
    </ModalWrapper>
  );
};

export default ExternalIntegrationOAuthErrorModal;
